
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./success.json") })
        }
      }, "path---success");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---success!./.cache/json/success.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---success!./.cache/json/success.json
// module chunks = 154